import type { AppLanguage } from '../shared/types';

/**
 * Arayüz dili (Ayarlar > Genel > Dil).
 *
 * Ana süreçte üretilip arayüzde gösterilen metinler (hata mesajları, diyalog
 * başlıkları, varsayılan toplantı adları) bu dile göre seçilir. Kalıcı değer
 * settings.json'da duruyor; settings.ts her okuma ve yazmada buraya bildirir.
 *
 * Yalnızca iki dil var, bu yüzden metinler ayrı bir sözlükte değil, kullanıldığı
 * yerde iki dilde birlikte yazılıyor: bir çeviri hiçbir zaman eksik kalamaz.
 */
let current: AppLanguage = 'tr';

export function setUiLanguage(language: AppLanguage): void {
  current = language;
}

export function uiLanguage(): AppLanguage {
  return current;
}

/** Tarih ve saat biçimlendirmesinin yerel ayarı. */
export function uiLocale(): 'tr-TR' | 'en-US' {
  return current === 'en' ? 'en-US' : 'tr-TR';
}

/** Türkçe ve İngilizce karşılığı verilen metinden geçerli dildekini seçer. */
export function t(tr: string, en: string): string {
  return current === 'en' ? en : tr;
}

export function isAppLanguage(value: unknown): value is AppLanguage {
  return value === 'tr' || value === 'en';
}
